<script lang="ts">
    import AqiGauge from '../../../public/icons/aqi_gauge.svelte';
    import AqiGaugePrimaryCondition from '../../../public/icons/aqi_gauge_primary_condition.svelte';
    import { getPollutantDisplayName, getPollutantTypeFromCondition } from '../../aqiHelpers';
    import { aqiData, widgetInfo, Widget, WidgetType, Pollutant, PollutantType } from '../../store';
    import { get } from 'svelte/store';

    export let isPrimaryCondition: boolean = false;
    export let pollutantType: PollutantType = PollutantType.PM2_5;

    let fill = '--default-color';
    let aqiColor = '';
    let conditionName = '';
    let conditionValue = null;
    let conditionText = '';

    function updateDisplay(pollutants: Pollutant[], pollutantType: PollutantType) {
        if (!pollutants) return;

        conditionName = getPollutantDisplayName(pollutantType);

        try {
            if (pollutantType === PollutantType.AQI) {
                let aqi = pollutants.find((pollutant) => pollutant.isMainPollutant);

                if (!aqi) {
                    aqi = pollutants[0];
                }

                conditionValue = aqi.aqiData.nowCastIndex?.value;
                conditionText = aqi.aqiData.nowCastIndex?.shortDescription;
                aqiColor = aqi.aqiData.nowCastIndex?.color;
            } else
            if (pollutants?.some((pollutant) => pollutant.pollutantType === pollutantType)) {
                const pollutant = pollutants.find((pollutant) => pollutant.pollutantType === pollutantType);

                conditionValue = pollutant.aqiData.nowCastIndex?.value;
                conditionText = pollutant.aqiData.nowCastIndex?.shortDescription;
                aqiColor = pollutant.aqiData.nowCastIndex?.color;
            } else {
                conditionValue = null;
                conditionText = '';
                aqiColor = '';
            }
        }
        catch (e) {
            console.error(e);
        }
    }

    widgetInfo.subscribe((value: Widget) => {
        if (!value) return;

        if(value.type != WidgetType.DEF && isPrimaryCondition){
            fill = "--primary-color"
        }

        // Get aqi data
        if (isPrimaryCondition) {
            let pollutantType = getPollutantTypeFromCondition(value.primaryCondition);

            updateDisplay(get(aqiData), pollutantType);
        }
    });

    aqiData.subscribe((pollutants: any) => {
        if (!pollutants) return;
        
        updateDisplay(pollutants, pollutantType);
    });
</script>

<div class="cc-container" style="color: var({fill})">
    {#if isPrimaryCondition}
        <div style="position: relative; width: 20rem; height: 15rem; display: flex; align-items: center; flex-direction: column;">
            <div style="font-size: 1.25rem;">
                {conditionName}
            </div>

            <div style="position: absolute; width: 20rem; height: 15rem; left:0; top: .5rem">
                {#key conditionValue}
                    <AqiGaugePrimaryCondition aqiValue={conditionValue} fill={aqiColor} />
                {/key}
            </div>

            <div style="display: flex; justify-content: center; align-items: center; height: 100%; flex-direction: column; position: absolute; top: 3rem; gap: 1rem;">
                <div style="font-size: 3.5rem;">
                    {conditionValue ?? '-'}
                </div>
            
                <div style="font-size: 1.25rem; margin-top: .5vw; text-align: center;">
                    {conditionText}
                </div>
            </div>
        </div>
    {:else}
        <div class="weatherIcon">
            <AqiGauge aqiValue={conditionValue} fill={aqiColor} />
        </div>

        <div class='value'>
            {conditionValue ?? '-'}
        </div>
    
        <div class='label' style="display: flex; justify-content: center; align-items: center;">
            <p>{conditionName}</p>
        </div>
    {/if}

    
</div>
